import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2jo44vh8jq: FaireBrandEntity = {
  token: "b_2jo44vh8jq",
  type: "brand",
  name: "Apothékary",
  avatarUrl:
    "https://cdn.faire.com/fastly/8befdfe005e6d2c3d35bea9bad44762f3b9b7a46660b0e5ba60b526451e53328.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6e3402e16c3229513c0b1d338c4092aa88ca56a57140af91b639b4c671d46893.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8befdfe005e6d2c3d35bea9bad44762f3b9b7a46660b0e5ba60b526451e53328.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6e3402e16c3229513c0b1d338c4092aa88ca56a57140af91b639b4c671d46893.jpeg",
  location: "Lorton, VA, USA",
  minimumOrderDollars: 149,
  rating: 4.8,
  reviewCount: 39,
  isInsider: true,
  description:
    "Apothékary started with our founder, Shizu Okusa, and her family’s traditional Japanese approach to healing—using nature as medicine instead of over-the-counter fixes. In many Eastern cultures, traditional medicine in the form of plants and herbs has been used for centuries to address the root cause of common ailments. That’s exactly what we strive to do here at Apothékary— we’re here to not just treat the symptom, but get to the root cause of your wellness woes.\n\nApothékary is on a mission to give ancient, plant-based healing traditions new life—so that you can live a more balanced one. We get too the root cause of one's illness and stress using nature as medicine.  All of our Signature Formulas contain medicinal plants and are thoughtfully formulated by our in-house Clinical Herbalists, pulling from traditional medicine modalities like Japanese Kampo, Traditional Chinese Medicine, Ayurveda, and American herbalism, and coupling with modern science. The result is simple yet effective herbal remedies backed by both tradition and research.\n\nEach formula contains herbs from local and global farmers with ingredients that are non- GMO, gluten-free, and contain no added sugar, fillers, or additives. In essence, they’re nature’s best remedies—plain and simple. And the best part is, they actually work to address the root cause instead of masking the symptoms.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:06.467Z",
    importedBy: "entity-db-cli",
  },
};
